import React, { useState, useEffect, useCallback, useContext } from "react";
import RenderTabs from "components/Tabs/Tabs";
import ViewPropertyDetails from "./PropertyDetails";
import { ArrowBack } from "@mui/icons-material";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { getPropertyById } from "actions/propertyActions";
import { useDispatch, useSelector } from "react-redux";
import { getPropertyData } from "selectors/propertySelectors";
import { Typography } from "@mui/material";
import { omit } from "lodash";
import { CustomBreadCrumb } from "components/BreadCrumb";
import PropertyOverview from "./PropertyOverview";
import PunchListPage from "pages/projects/tabComponents/PunchList";
import Warranty from "pages/projects/tabComponents/warranty/Warranty";
import AppRoleContext from "context/AppRoleContext";
import {
  FREE_SUBSCRIPTION,
  hasSubscription,
  isBuilderAdmin,
  isHomeOwner,
} from "core/utils/roleUtils";
import { getUserProfileDetails } from "selectors/appSelector";
import ChangeOrders from "pages/change_order/ChangeOrders";

const tabs = [
  {
    key: "propertyDetails",
    label: "Site Information",
    TabComponent: ViewPropertyDetails,
  },
  {
    key: "propertyProjects",
    label: "View Projects",
    TabComponent: PropertyOverview,
    tabProps: { hideTitle: false },
    hide: ({ appRoleDetails, userProfile }) => {
      if (isHomeOwner(appRoleDetails)) {
        return true;
      }
      if (
        isBuilderAdmin(appRoleDetails) &&
        hasSubscription(userProfile, FREE_SUBSCRIPTION)
      ) {
        return true;
      }
      return false;
    },
  },
  {
    key: "punchList",
    label: "PunchList",
    TabComponent: PunchListPage,
    // hide: ({ userProfile }) => !hasSubscription(userProfile, FREE_SUBSCRIPTION),
  },
  {
    key: "warranty",
    label: "Warranty",
    TabComponent: Warranty,
    // hide: ({ userProfile }) => {
    // 	return !hasSubscription(userProfile, FREE_SUBSCRIPTION);
    // },
  },
  {
    key: "changeOrders",
    label: "Change Orders",
    TabComponent: ChangeOrders,
    hide: ({ appRoleDetails }) => !isHomeOwner(appRoleDetails),
  },
];

export const ViewProperty = () => {
  const userProfile = useSelector(getUserProfileDetails);
  const { state = {} } = useLocation();

  const [selectedTab, updateTab] = useState("propertyDetails");

  // 	hasSubscription(userProfile, FREE_SUBSCRIPTION)
  // 		? "propertyDetails"
  // 		: "propertyProjects"

  const appRoleDetails = useContext(AppRoleContext);

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const propertyRawData = useSelector(getPropertyData);
  const propertyData = omit(propertyRawData, ["projectHeaderList"]);

  const getPropertyDetails = useCallback(() => {
    dispatch(getPropertyById(params.propertyId));
  }, [dispatch, params.propertyId]);

  useEffect(() => {
    if (params.tab) {
      updateTab(params.tab);
    }
  }, [params]);

  useEffect(() => {
    getPropertyDetails();
  }, [getPropertyDetails]);

  return (
    <>
      <div className="ms-3 mt-2 mb-1">
        <button
          className="outlinedButton"
          style={{
            width: "fit-content",
            height: "1.7rem",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => navigate("/properties")}
        >
          <ArrowBack
            style={{
              height: "20px",
              width: "23px",
              color: "#345DAE",
              marginBottom: "0.4rem",
            }}
            className="pointer mt-2"
          />
          Back
        </button>
      </div>
      <div className="d-flex align-items-center">
        <Typography
          className="h3 ms-2 mt-2"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "15rem",
          }}
        >
          {propertyData?.propertyName}
        </Typography>
      </div>
      <CustomBreadCrumb breadCrumbItems={["properties", "propertyName"]} />

      <div className="project-tabs tabs">
        <RenderTabs
          className="tab-list"
          tabs={tabs}
          selectedTab={selectedTab}
          onTabClick={(newTab) => {
            updateTab(newTab);
            navigate(`/properties/${params.propertyId}/${newTab}`, {
              state,
            });
          }}
          tabParams={{
            propertyId: params.propertyId,
            propertyData,
            fromProperty: true,
            appRoleDetails,
            userProfile,
          }}
        />
      </div>
      <div className="project-tab-content"></div>
    </>
  );
};

export const RedirectToProperty = () => {
  const { propertyId } = useParams();
  return <Navigate to={`/properties/${propertyId}`} replace />;
};

export default ViewProperty;
